import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import { Switch } from "antd";

interface Props {
  isToggled: boolean;
  label?: string;
  onChange?: (
    checked: boolean,
    event: React.MouseEvent<HTMLButtonElement>
  ) => void;
  id?: string;
  checked?: boolean;
  disabled?: boolean;
  size?: "default" | "small";
  hideButton?: boolean;
  dataTestId?: string;
}

const ToggleComponent = ({
  label,
  isToggled,
  onChange,
  id,
  checked,
  disabled,
  size = "default",
  hideButton = false,
  dataTestId = "toggle-component",
}: Props) => (
  <ToggleContainer size={size} hideButton={hideButton}>
    <Switch
      id={id}
      disabled={disabled}
      // style={{ transform: "scale(1.1)" }}
      checkedChildren={label ? label : "ON"}
      unCheckedChildren={label ? label : "OFF"}
      onChange={onChange}
      checked={checked}
      defaultChecked={isToggled}
      data-testid={dataTestId}
    />
  </ToggleContainer>
);

const ToggleContainer = styled.div<{
  size: "default" | "small";
  hideButton: boolean;
}>`
  > button {
    padding: 0;
  }

  .ant-switch,
  .ant-switch:hover .ant-switch-inner {
    background-color: ${COLORS.TOGGLE};
  }
  .ant-switch-checked,
  .ant-switch-checked:hover .ant-switch-inner {
    background-color: ${({ theme }) =>
      theme.value === "light" ? theme.COLORS.BUTTONS1 : COLORS.BUTTONS2};
  }
  .ant-switch-inner {
    font-weight: 500;
    > span {
      font-size: ${calcRem(12)} !important;
    }
  }
  ${({ hideButton }) =>
    hideButton &&
    `
      .ant-switch.ant-switch-disabled {
        opacity: 1 !important;
      }
      .ant-switch-handle {
        display: none !important;
      }
      .ant-switch-inner {
        padding: 0 9px !important;
      }
    `}
  .ant-switch-checked:focus {
    box-shadow: unset;
  }
`;

export default ToggleComponent;
